import { Routes } from '@angular/router';
import { nlScheduleVirtualAppointmentRoutes } from '@features/nl-schedule-virtual-appointment/nl-schedule-virtual-appointment.routes';

export const programRoutes: Routes = [
  {
    path: ':programId/hub',
    loadComponent: () => import('./pages/program-hub/program-hub.page').then((m) => m.ProgramHubPage),
  },
  {
    path: ':programId/preparing-offer',
    loadComponent: () =>
      import('./pages/preparing-offer/preparing-offer.component').then((m) => m.PreparingOfferComponent),
    data: {
      background: 'assets/splash_intake.png',
    },
  },
  {
    path: ':programId/hub/schedule',
    loadComponent: () =>
      import(
        '@features/nl-schedule-virtual-appointment/pages/nl-schedule-appointment-base/nl-schedule-appointment-base.page'
      ).then((m) => m.NlScheduleAppointmentBasePage),
    children: nlScheduleVirtualAppointmentRoutes,
  },
  {
    path: ':type',
    children: [
      {
        path: '',
        redirectTo: 'select-user',
        pathMatch: 'full',
      },
      {
        path: 'select-user',
        loadComponent: () => import('./pages/select-user/select-user.page').then((m) => m.SelectUserPage),
      },
    ],
  },
];
